import { render, staticRenderFns } from "./CreateModel.vue?vue&type=template&id=400cc608&"
import script from "./CreateModel.vue?vue&type=script&lang=js&"
export * from "./CreateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateModel.vue"
export default component.exports